import { env } from '@util/Environment.js'

export const paymentMethodConfigProvider = () => {
    const environment = env()

    if (environment === 'development') {
        return process.env.VUE_APP_STRIPE_PAYMENT_METHOD_CONFIGURATION_DEV
    }

    if (environment === 'production') {
        return process.env.VUE_APP_STRIPE_PAYMENT_METHOD_CONFIGURATION
    }

    return null
}

export const stripeKeyProvider = () => {
    const environment = env()

    if (environment === 'development') {
        return process.env.VUE_APP_STRIPE_KEY_LOCAL
    }

    if (environment === 'production') {
        return process.env.VUE_APP_STRIPE_KEY
    }

    return null
}

export const stripeKey = stripeKeyProvider()
export const paymentMethodConfig = paymentMethodConfigProvider()
